/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const CommentGuardIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0)" fill={color}>
        <path d="M14.82 2.156H7.71c-.65 0-1.18.53-1.18 1.18v.74H1.184c-.651 0-1.18.53-1.18 1.181v.56a.316.316 0 10.632 0v-.56c0-.302.245-.548.548-.548h7.108c.302 0 .548.246.548.548v4.827a.548.548 0 01-.548.548H5.236a.316.316 0 00-.24.109l-1.132 1.306-1.268-1.319a.316.316 0 00-.228-.096H1.184a.548.548 0 01-.548-.548v-1.77a.316.316 0 00-.633 0v1.77c0 .65.53 1.18 1.18 1.18h1.05l1.415 1.47c.06.062.142.097.228.097h.008a.316.316 0 00.231-.109l1.204-1.388v1.287c0 .651.53 1.18 1.18 1.18h1.05l1.415 1.47c.06.063.142.098.228.098H9.2a.316.316 0 00.23-.11l1.266-1.458h2.912c.65 0 1.18-.529 1.18-1.18V9.343h.032c.65 0 1.18-.53 1.18-1.18V3.337c0-.651-.53-1.18-1.18-1.18zm-.664 10.465a.549.549 0 01-.548.548h-3.057a.316.316 0 00-.239.11L9.18 14.583l-1.268-1.318a.316.316 0 00-.228-.097H6.499a.549.549 0 01-.547-.548v-1.357h2.34c.651 0 1.18-.53 1.18-1.18v-.74h1.152l1.264 1.458a.316.316 0 00.467.012l1.415-1.47h.386v3.277zm1.212-4.458a.548.548 0 01-.548.548h-1.185a.316.316 0 00-.227.097l-1.269 1.318-1.132-1.306a.316.316 0 00-.24-.109H9.474V5.257c0-.65-.53-1.18-1.18-1.18h-1.13v-.74c0-.303.246-.548.548-.548h7.109c.302 0 .548.245.548.548v4.826z" />
        <path d="M.225 7.369l.007.002a.316.316 0 00.183-.605l-.007-.003a.316.316 0 00-.183.606zM10.382 6.255l.007.002a.316.316 0 00.182-.606l-.007-.001a.316.316 0 00-.182.605zM2.003 7.658l.007.002a.316.316 0 00.182-.606l-.007-.002a.316.316 0 00-.182.606zM14.102 4.236h-3.625a.316.316 0 000 .633h3.625a.316.316 0 100-.633zM5.723 5.639H2.097a.316.316 0 000 .632h3.626a.316.316 0 100-.632z" />
        <path d="M7.941 5.639H4.316a.316.316 0 000 .632h3.625a.316.316 0 100-.632zM14.102 5.606h-2.35a.316.316 0 000 .632h2.35a.316.316 0 100-.632zM5.723 7.008h-2.35a.316.316 0 000 .633h2.35a.316.316 0 100-.633z" />
        <path d="M7.906 7.007h-2.35a.316.316 0 000 .632h2.35a.316.316 0 100-.632zM2.667 8.306l.299.477.546.137-.362.432.04.562-.523-.211-.523.21.04-.561-.363-.432.547-.137.299-.477zM4.889 8.306l.299.477.546.137-.362.432.04.562-.523-.211-.523.21.04-.561-.362-.432.546-.137.299-.477zM7.111 8.306l.299.477.546.137-.361.432.039.562-.523-.211-.522.21.039-.561-.362-.432.546-.137.3-.477z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 .75h16v16H0v-16z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};
